import { pilot } from '~/services/serviceInstances';
import { bytesToBlob } from '~/utils/files';

interface Request {
  documentId: string;
  attachmentId: string;
}

export const downloadDocumentAttachment = async (
  request: Request,
): Promise<Blob> => {
  const { documentId, attachmentId } = request;
  const config = { responseType: 'blob' as const };

  const response = await pilot.get(
    `document/${documentId}/attachment/${attachmentId}`,
    config,
  );
  return bytesToBlob(response, (response as any).type);
};
